import { render, staticRenderFns } from "./LuckyGiftWheel.vue?vue&type=template&id=30d1b3fe&scoped=true"
import script from "./LuckyGiftWheel.vue?vue&type=script&lang=js"
export * from "./LuckyGiftWheel.vue?vue&type=script&lang=js"
import style0 from "./LuckyGiftWheel.vue?vue&type=style&index=0&id=30d1b3fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d1b3fe",
  null
  
)

export default component.exports